import { z } from 'zod'

export const SettingsSchema = z.object({
  display_showVideo: z.boolean().default(true),
  display_showStickFigure: z.boolean().default(true),
  display_showAvatar: z.boolean().default(false),
  display_show3DAvatar: z.boolean().default(false),

  preview_showVideo: z.boolean().default(true),
  preview_showStickFigure: z.boolean().default(false),
  preview_showAvatar: z.boolean().default(false),

  debug_showStatus: z.boolean().default(true),
  debug_showGraph: z.boolean().default(true),
  debug_showJointBars: z.boolean().default(false),

  enableEnhancedHands: z.boolean().default(false),

  selectedCameraId: z.string().default(''),
  selectedCameraLabel: z.string().default(''),

  preferredResolution: z.object({
    width: z.number(),
    height: z.number(),
  }).default({ width: 640, height: 480 }),
})
